<template>
    <div class="col-lg-9">
        <h2 class="font-weight-400 mb-3">Transactions</h2>

        <!-- Filter ============================================= -->
        <div class="row">
            <div class="col mb-2">
                <form  @submit.prevent="data.fetch()" method="post">
                    <div class="form-row">
                        <!-- Date Range
                        ========================= -->
                        <div class="col-sm-3 col-md-2 form-group">
                            <select @change="data.fetch()" v-model="data.filters.size" class="custom-select"
                                    required="">
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="col-sm-6 col-md-5 form-group">
                            <input type="text" class="form-control" v-model="data.filters.search"
                                   placeholder="Search...">
                            <span class="icon-inside"><i class="fas fa-search"></i></span>
                        </div>
                        <div class="col-auto d-flex align-items-center ml-auto form-group">
                            <button @click.prevent="data.fetch()"
                                    class="btn btn-primary btn-sm text-white px-3 shadow-none"
                                    :class="[ data.loading ? 'btn-loading' : '']">
                                <i class="fas fa-search"></i> Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Filter End -->

        <!-- All Transactions ============================================= -->
        <div class="bg-light shadow-sm rounded py-4 mb-4">
            <h3 class="text-5 font-weight-400 d-flex align-items-center px-4 mb-3">All Transactions</h3>
            <!-- Title =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 col-sm-1 text-center"><span class="">Date</span></div>
                    <div class="col col-sm-7">Description</div>
                    <div class="col-auto col-sm-2 d-none d-sm-block text-center">Status</div>
                    <div class="col-3 col-sm-2 text-right">Amount</div>
                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List =============================== -->
            <div class="transaction-list">
                <div v-for="row in data.content.data" :key="row.id" class="transaction-item d-block px-4 py-3">
                    <div class="row align-items-center flex-row">
                        <template v-if="row.t_type === 'zesa'">
                            <div class="col col-sm-7">
                                <span class="d-block text-4">ZESA {{ row.transaction.meter }}</span>
                                <span class="text-muted">{{ row.transaction.token }}</span>
                            </div>
                            <div class="col-auto col-sm-2 d-none d-sm-block text-center text-3">
                            <span class="text-warning" title="In Progress">
                                <i class="fas fa-ellipsis-h"></i>
                            </span>
                            </div>
                            <div class="col-3 col-sm-2 text-right text-4">
                                <span class="text-nowrap">- {{ row.transaction.amount }}</span>
                                <span class="text-2 text-uppercase">(USD)</span>
                            </div>
                        </template>
                        <template v-if="row.t_type === 'airtime'">
                            Network : {{ row.transaction.network }} <br>
                            Phone : {{ row.transaction.phone }} <br>
                        </template>
                        <template v-if="row.t_type === 'bundles'">
                            Network : {{ row.transaction.network }} <br>
                            Phone : {{ row.transaction.account }} <br>
                        </template>
                    </div>
                </div>
            </div>
            <!-- Transaction List End -->


            <!-- Transaction Item Details Modal End -->

            <!-- Pagination ============================================= -->
            <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                <ul class="pagination justify-content-center mt-4 mb-0">
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <li class="page-item active">
                        <a @click="data.append()"
                           v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                           class="page-link" href="#">
                            Load More <span class="sr-only">(current)</span>
                        </a>
                    </li>
                    <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                        <span>...</span>
                    </li>
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Paginations end -->

        </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";

export default {
    name: "Index",
    data() {
        return {
            data: new Data({
                url: "/business/transactions/list",
                prefix: "list"
            }),
        };
    },
    computed: {
        batchCode(){
            return this.$route.params.batchCode
        },
        batch(){
            return this.data.content.data.find(t => true)
        }
    },
    mounted() {


        if (this.$route.query.batch_id) {
            this.data.filters['batch_id'] = this.$route.query.batch_id;
        }

        this.data.fetch()
    }
}
</script>

<style scoped>

</style>
